import React, { useEffect, useState } from 'react'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core'

import { FONTS } from 'src/shared/theme'
import styled from 'styled-components'
import Tooltip from 'src/shared/views/Tooltip'

const StyledTypography = styled(Typography)`
  font-family: ${FONTS.main};
  color: ${(props) => props.theme.palette.common.black};
  font-size: 16px;
  letter-spacing: 0;
  font-weight: 300;
  line-height: 19px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

const SubHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-bottom: 10px;
`

const StyledTextField = styled(TextField)`
  margin: 5px;
`
const Container = styled.div`
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 10px;
`

type MaxCapacitySelectorProps = {
  value: number | null | undefined
  onChange: (value: number | null | undefined) => void
  utilizedCapacity: number | undefined
}

const MaxCapacitySelector: React.FC<MaxCapacitySelectorProps> = ({
  value,
  onChange,
  utilizedCapacity
}) => {
  const [capacityType, setCapacityType] = useState<string>(
    value ? 'unlimited' : 'maximum'
  )

  const [maxCapacity, setMaxCapacity] = useState<number>(value ?? 100)

  useEffect(() => {
    if (value === null || value === undefined) {
      setCapacityType('unlimited')
    } else {
      setCapacityType('maximum')
    }
  }, [value])

  const handleCapacityTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCapacityType(event.target.value)
    if (event.target.value === 'maximum') {
      onChange(maxCapacity)
    } else {
      onChange(null)
    }
  }

  const handleMaxCapacityInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMaxCapacity(parseInt(event.target.value))
    onChange(parseInt(event.target.value))
  }

  return (
    <Container>
      <Header>
        <h4>Capacity</h4>
      </Header>
      <SubHeader>
        <RadioGroup value={capacityType} onChange={handleCapacityTypeChange}>
          <FormControlLabel
            value="unlimited"
            control={<Radio />}
            label="Unlimited"
          />
          <FormControlLabel
            value="maximum"
            control={<Radio />}
            label="Maximum"
          />
          <StyledTextField
            defaultValue={maxCapacity}
            type="number"
            size="small"
            variant="outlined"
            InputProps={{ inputProps: { min: 0 } }}
            disabled={capacityType !== 'maximum'}
            onChange={handleMaxCapacityInputChange}
          />
        </RadioGroup>
        <Tooltip description="Utilized capacity is the sum of verified and verified expired memberships.">
          <StyledTypography>
            <p
              style={{
                color:
                  utilizedCapacity === undefined || capacityType === 'unlimited'
                    ? 'green'
                    : utilizedCapacity < maxCapacity
                    ? 'green'
                    : utilizedCapacity > maxCapacity
                    ? 'red'
                    : ''
              }}
            >
              Utilized: {utilizedCapacity ?? 0}
            </p>
          </StyledTypography>
        </Tooltip>
      </SubHeader>
    </Container>
  )
}

export default MaxCapacitySelector
